import React from 'react';
import ButtonNavigation from './button/ButtonNavigation';
import NumberNavigation from './number/NumberNavigation';
import './Navigation.scss';

export interface NavigationProps {
    listIndex: number;
    endIndex: number;
    dispatchSetListIndexAction: (index: number) => void;
    dispatchIncrementListIndexAction: () => void;
    dispatchDecrementListIndexAction: () => void;
}

const UI_PAGE_LIMIT = 5;

export default function Navigation(props: NavigationProps) {
    const { endIndex } = props;

    const displayNumberNavigation = endIndex < UI_PAGE_LIMIT;
    return (
        <div className="Navigation">
            {displayNumberNavigation ? (
                <NumberNavigation {...props} />
            ) : (
                <ButtonNavigation {...props} />
            )}
        </div>
    );
}
